/* eslint-disable max-len */
import lessRequire from '../../config/less-require-resolver';

import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import isEmpty from 'lodash/isEmpty';

import { actions, selectors } from '../user-api';

import renderViewsState from '../shared/render-views-state';
import Manager from '../shared/manager';

const images = require.context('../../apps/rocket/assets/img/keitaro-integration', true);

lessRequire('modules/keitaro-integration/main.less');

const Main = renderViewsState(({ intl, user, manager }) => {
	return (
		<div className='container__with-columns container keitaro-integration'>
			<div className='column_left container__content' hidden={intl.language !== 'ru'}>
				<div className='container__content-title'>
					<h2 className='font-proxima-nova-bold'>
            Настройка Keitaro
					</h2>
				</div>

				<div className='container__content-block'>
					Как установить трекер Keitaro можно изучить <Link to='https://docs.keitaro.io/ru/get-started/auto-installation.html' target='_blanck'>здесь</Link> или же обратиться в техподдержку Keitaro.
				</div>
				<div className='container__content-block'>
					Сегодня мы рассмотрим следующие варианты настройки офферов Rocketprofit в трекере:
				</div>
				<div className='container__content-block'>
					<b>1. Редирект на оффер.</b>
				</div>
				<div className='container__content-block'>
					<b>2. Локальный лендинг (с транзитной страницей и без).</b>
				</div>
				<div className='container__content-block'>
					Независимо от выбора схемы, в первую очередь нам необходимо создать шаблон партнерской сети. Переходим на вкладку Affiliate Networks(Партнерские сети) и нажимаем Create(Создать):
					<img src={images('./ru/1.png')} />
				</div>
				<div className='container__content-block'>
					В выпадающем списке выбираем Rocketprofit и нажимаем Create(Создать).
				</div>
				<div className='container__content-block'>
					Теперь обязательно вставляем ссылку Postback URL из шаблона Keitaro в Глобальный постбек или поток в личном кабинете Rocketprofit:
					<img src={images('./ru/2.png')} />
				</div>
				<div className='container__content-block'>
					О том, что такое постбек и чем отличается постбек на потоке от глобального постбэка, можно прочесть <Link to='/postback-info'>тут</Link>.
				</div>
				<div className='container__content-block'>
					Теперь создадим нашу кампанию в трекере.
				</div>
				<div className='container__content-block'>
					Переходим на вкладку Campaigns(Кампании) и нажимаем Create(Создать):
					<img src={images('./ru/3.png')} />
				</div>
				<div className='container__content-block'>
					Откроется страница создания кампании, вводим название кампании и нажимаем Create(Создать).
				</div>
				<div className='container__content-block'>
					Теперь рассмотрим работу с каждой отдельной схемой.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Редирект на оффер
					</h3>
					В созданной кампании нажимаем Create flow(Создать поток):
					<img src={images('./ru/4.png')} />
				</div>
				<div className='container__content-block'>
					Далее вкладка Schema(Схема) – Landing pages & offers(Лендинги и офферы) – Offers(Офферы) – Create Offer(Создать оффер):
					<img src={images('./ru/5.png')} />
				</div>
				<div className='container__content-block'>
					В открывшемся окне заполняем следующие поля:
				</div>
				<div className='container__content-block'>
					Offer name(Название) – название нашего оффера;
				</div>
				<div className='container__content-block'>
					Affiliate network(Партнерская сеть) – выбор шаблона партнерской сети, который будет применен к нашему офферу;
				</div>
				<div className='container__content-block'>
					Redirect type(Редирект) – тип редиректа, в нашем случае HTTP;
				</div>
				<div className='container__content-block'>
					URL – Ссылка нашего потока, ранее созданного в Rocketprofit;
				</div>
				<div className='container__content-block'>
					Нажимаем Create(Создать).
					<img src={images('./ru/6.png')} />
				</div>
				<div className='container__content-block'>
					После добавления потока сохраните изменения в кампании. Кампания настроена и готова к работе, проверить можно использовав ссылку кампании, перейдя по которой, можно выполнить тестовую заявку:
					<img src={images('./ru/7.png')} />
				</div>
				<div className='container__content-block'>
					Информацию о том, что постбек из партнерской сети получен, можно получить в разделе Maintenance – Logs – Received Postbacks
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Локальный лендинг с транзитной страницей
					</h3>
					Шаг 1. На странице потока в кабинете Rocketprofit, нужно скачать транзитную страницу и основной лендинг.
					<img src={images('./ru/8.png')} />
				</div>
				<div className='container__content-block'>
					Перед скачиванием транзитной страницы, нас попросят указать ссылку на наш лендинг, в поле прописываем макрос <b>&#123;offer&#125;</b>.
				</div>
				<div className='container__content-block'>
					В Keitaro при работе с лендингом+транзитной страницей используется схема Лендинг + Оффер. Таким образом, Лендингом выступает транзитная страница, а оффером – основной лендинг.
					<img src={images('./ru/9.png')} />
				</div>
				<div className='container__content-block'>
					Шаг 2. В созданной кампании нажимаем <b>Create flow(Создать поток)</b> как в предыдущей схеме.
				</div>
				<div className='container__content-block'>
					Шаг 3. Вкладка Schema(Cхема) – Landing pages & offers(Лендинги и офферы) – Landing pages(Лендинги) – Create landing page(Добавить лендинг)
					<img src={images('./ru/10.png')} />
				</div>
				<div className='container__content-block'>
					В открывшемся окне заполняем следующие поля:
				</div>
				<div className='container__content-block'>
					Name(Название) – название нашей транзитной страницы;
				</div>
				<div className='container__content-block'>
					Group(Группа) – возможность создания группы и сортировки по группе в дальнейшем(по желанию);
				</div>
				<div className='container__content-block'>
					Local(Локальный) – тип загрузки;
				</div>
				<div className='container__content-block'>
					Zip-file(Zip-архив) – выбор нашего архива с транзитной страницей;
				</div>
				<div className='container__content-block'>
					Folder(Папка) – изменение имени папка на сервере (лучше оставить по умолчанию);
					<img src={images('./ru/11.png')} />
				</div>
				<div className='container__content-block'>
					После загрузки и сохранения получаем поток с прикрепленным лендингом (транзитной страницей). Теперь осталось таким же образом создать и загрузить оффер (основной лендинг) и прикрепить его в потоке в уже созданному лендингу.
				</div>
				<div className='container__content-block'>
					Шаг 4. Открываем наш поток с лендингом и нажимаем Create Offer(Создать оффер):
					<img src={images('./ru/12.png')} />
				</div>
				<div className='container__content-block'>
					По аналогии с созданием лендинга, выбираем локальный тип оффера и загружаем скачанный ранее архив из Rocketprofit с основным лендингом.
				</div>
				<div className='container__content-block'>
					После загрузки и сохранения мы получаем связку Лендинг и оффер внутри потока:
					<img src={images('./ru/13.png')} />
				</div>
				<div className='container__content-block'>
					Сохраните изменения в кампании. Далее необходимо перейти по ссылке кампании и проверить работу постбэка.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Локальный лендинг без транзитной страницы
					</h3>
					Локальный лендинг без транзитной страницы настраивается точно так же, как и с транзитной страницей. Вам лишь нужно скачать основной лендинг, и следовать предыдущей инструкции, а по добавлению промо в трекер начать путь с Шага 4.
				</div>
			</div>

			<div className='column_left container__content' hidden={intl.language === 'ru'}>
				<div className='container__content-title'>
					<h2 className='font-proxima-nova-bold'>
						Keitaro setup
					</h2>
				</div>

				<div className='container__content-block'>
					Learn how to install Keitaro tracker <Link to='https://docs.keitaro.io/en/get-started/auto-installation.html' target='_blanck'>here</Link> or contact Keitaro technical support.
				</div>
				<div className='container__content-block'>
					Today we will review the following options for configuring Rocketprofit offers in the tracker:
				</div>
				<div className='container__content-block'>
					<b>1. Redirect to offer.</b>
				</div>
				<div className='container__content-block'>
					<b>2. Local landing page (with and without a transit page).</b>
				</div>
				<div className='container__content-block'>
					Regardless of the scheme chosen, the first step is to create an affiliate network template. Go to the Affiliate Networks tab and click Create:
					<img src={images('./en/1.png')} />
				</div>
				<div className='container__content-block'>
					Select Rocketprofit from the drop-down list and click Create.
				</div>
				<div className='container__content-block'>
					Now you must insert the Postback URL link from the Keitaro template into the Global Postback or stream in your Rocketprofit personal account:
					<img src={images('./en/2.png')} />
				</div>
				<div className='container__content-block'>
					To read about postback and how in-stream postback differs from global postback, click <Link to='/postback-info'>here</Link>.
				</div>
				<div className='container__content-block'>
					Let's now create a campaign in the tracker.
				</div>
				<div className='container__content-block'>
					Go to the Campaigns tab and click Create:
					<img src={images('./en/3.png')} />
				</div>
				<div className='container__content-block'>
					The campaign creation page will open, enter the campaign name and click Create.
				</div>
				<div className='container__content-block'>
					Now let's look at working with each individual scheme.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Redirect to offer
					</h3>
					In the created campaign, click Create flow:
					<img src={images('./en/4.png')} />
				</div>
				<div className='container__content-block'>
					Next tab Schema – Landing pages & offers – Offers – Create Offer:
					<img src={images('./en/5.png')} />
				</div>
				<div className='container__content-block'>
					Fill in the following fields in the pop-up window:
				</div>
				<div className='container__content-block'>
					Offer name - the name of your offer;
				</div>
				<div className='container__content-block'>
					Affiliate network – select an affiliate network template that will be applied to your offer;
				</div>
				<div className='container__content-block'>
					Redirect – redirect type, in our case HTTP;
				</div>
				<div className='container__content-block'>
					URL – your stream link, previously created in Rocketprofit;
				</div>
				<div className='container__content-block'>
					Click Create.
					<img src={images('./en/6.png')} />
				</div>
				<div className='container__content-block'>
					After adding the stream, save the changes to the campaign. The campaign is all set and ready to work. To preview, click the campaign link and run a test:
					<img src={images('./en/7.png')} />
				</div>
				<div className='container__content-block'>
					If you want to double-check the postback receipt from the affiliate network, go Maintenance – Logs – Received Postbacks section.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Local landing page with a transit page
					</h3>
					Step 1. From the stream page in your Rocketprofit account, download both the transit page and the main landing page.
					<img src={images('./en/8.png')} />
				</div>
				<div className='container__content-block'>
					Before downloading the transit page, you will be asked to provide a link to your landing page; enter the macro <b>&#123;offer&#125;</b> in the field.
				</div>
				<div className='container__content-block'>
					In Keitaro, when working with landing + transit page, the Landing + Offer scheme is used. Thus, the landing page is the transit page, and the main landing page is the offer.
					<img src={images('./en/9.png')} />
				</div>
				<div className='container__content-block'>
					Step 2. Click <b>Create flow</b> in the campaign created, as in the previous scheme.
				</div>
				<div className='container__content-block'>
					Step 3. The Schema tab – Landing pages & offers – Landing pages – Create landing page
					<img src={images('./en/10.png')} />
				</div>
				<div className='container__content-block'>
					Fill in the following fields in the pop-up window:
				</div>
				<div className='container__content-block'>
					Name - the name of your transit page;
				</div>
				<div className='container__content-block'>
					Group – the ability to create a group and filter by group in the future (optional);
				</div>
				<div className='container__content-block'>
					Local – download type;
				</div>
				<div className='container__content-block'>
					Zip-file (Zip archive) – select your archive with a transit page;
				</div>
				<div className='container__content-block'>
					Folder - change the name of the folder on the server (better to leave it by default);
					<img src={images('./en/11.png')} />
				</div>
				<div className='container__content-block'>
					After downloading and saving, you will receive a stream with an attached landing page (transit page). All you now need to do using the same method is to create and upload an offer (the main landing page) and attach it to the already created landing page in the stream.
				</div>
				<div className='container__content-block'>
					Step 4. Open your landing page stream and click Create Offer:
					<img src={images('./en/12.png')} />
				</div>
				<div className='container__content-block'>
					Just like with creating a landing page, select the local offer type and upload the previously downloaded archive from Rocketprofit with the main landing page.
				</div>
				<div className='container__content-block'>
					After uploading and saving, we get the landing page and the offer inside the stream:
					<img src={images('./en/13.png')} />
				</div>
				<div className='container__content-block'>
					Save the changes to the campaign. Next, you need to click on the campaign link and check the postback is working.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Local landing page without a transit page
					</h3>
					A local landing page without a transit page is configured in the same way as with a transit page. You just need to download the main landing page and follow the previous instructions; to add a promo to the tracker start from Step 4.
				</div>
			</div>

			<div className='column_right'>
				{!isEmpty(manager) && (
					<Manager
						data={manager}
						user={user}
						intl={intl}
					/>
				)}
			</div>
		</div>
	);
});

export default connect(
	state => ({
		manager: selectors.getManager(state),
		user: selectors.getUserData(state),
		data: selectors.getData(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/keitaro-integration/main.js